var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":"Currency Exchange Rate"}},[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"Tax Rate"}},[_c('tax-rate')],1),_c('vs-tab',{attrs:{"label":"Daily Rate"}},[_c('bi-rate')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }